import { postWithCancel } from "@/api/getApi2.0";
import { ENTITY_NAME_IN_URI } from "@/api/config/api2.0";

export const getCampaignsGlobal = (
  axios,
  params = {},
  data = {},
  options = {}
) =>
  postWithCancel(
    {
      path: ENTITY_NAME_IN_URI.DASHBOARD.CAMPAIGNS.path,
      ressources: [
        {
          name: ENTITY_NAME_IN_URI.DASHBOARD.CAMPAIGNS.GLOBAL
        }
      ]
    },
    params,
    data,
    axios,
    options
  );

export const getCampaignsDaily = (
  axios,
  params = {},
  data = {},
  options = {}
) =>
  postWithCancel(
    {
      path: ENTITY_NAME_IN_URI.DASHBOARD.CAMPAIGNS.path,
      ressources: [
        {
          name: ENTITY_NAME_IN_URI.DASHBOARD.CAMPAIGNS.DAILY
        }
      ]
    },
    params,
    data,
    axios,
    options
  );
